import { Group } from '@mantine/core'
import { forwardRef } from 'react'
import type { Props } from '../node/definition'

export default forwardRef((p: Props) => {
	return (
		<Group {...p} {...p.customProps} wrap={p.wrap ? 'wrap' : 'nowrap'}>
			{p.children}
		</Group>
	)
})
